import { shiftModalRoutingService } from 'components/ShiftModal/ShiftModal.ui.context';
import { useShiftModalDataContext } from 'components/ShiftModal/ShiftModalProvider.data.context';
import { getConfirmAvailabilityQueryConfig } from 'components/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/ConfirmAvailabilityModal.constants';
import { useGQLQuery } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import { FetchOrderCanAssignQuery, FetchOrderCanAssignQueryVariables } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

interface ICanAssignValidation {
  validateAndExecute: () => void;
}

export const CanAssignValidationContext = createGQLDataContext<ICanAssignValidation>(
  {} as ICanAssignValidation,
);

export const CanAssignValidationProvider: FC = ({ children }) => {
  const {
    data: {
      fetchOrder: { id: orderId },
    },
  } = useShiftModalDataContext();
  const { fetch } = useGQLQuery<
    FetchOrderCanAssignQuery,
    FetchOrderCanAssignQuery,
    FetchOrderCanAssignQueryVariables
  >(
    getConfirmAvailabilityQueryConfig({
      orderId,
      onSuccess: (data: FetchOrderCanAssignQuery) => {
        if (data.fetchOrder.canAssign) {
          shiftModalRoutingService.goToView('AssignToAgencyTeamMemberView');
        } else {
          shiftModalRoutingService.goToView('ShiftUnavailableView');
        }
      },
      onError: () => {
        shiftModalRoutingService.goToView('ShiftModalErrorView');
      },
    }),
  );
  const contextValue = useMemo<ICanAssignValidation>(
    () => ({ validateAndExecute: fetch }),
    [fetch],
  );

  return (
    <CanAssignValidationContext.Provider value={contextValue}>
      {children}
    </CanAssignValidationContext.Provider>
  );
};

export const useCanAssignValidationContext = (): ICanAssignValidation =>
  useContext(CanAssignValidationContext);
